var map = {
	"./auth.js": 6889,
	"./common.js": 3115,
	"./courses.js": 6327,
	"./lang.js": 6145,
	"./lessonTests.js": 5166,
	"./lessons.js": 4841,
	"./modals.js": 4928,
	"./pages.js": 1458,
	"./partners.js": 2143,
	"./questions.js": 6705,
	"./roles.js": 7350,
	"./tests.js": 5218,
	"./users.js": 4742,
	"./variants.js": 8481
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4925;